import moment from "moment";
import { ModelBase } from "../abstract/model-base.model";
import { Client } from "../client/client.model";
import { User } from "../user/user.model";
import { AssistantClient } from "./assistant-client.model";

/**
 * Autorisation donnée à un assistant IA sur un dossier (#1312) : l'assistant agit
 * avec les droits de `user` sur `client`, jusqu'à révocation. Une autorisation
 * révoquée reste listée, avec son statut.
 */
export class AssistantGrant extends ModelBase {

    static override CLASS_NAME: string = 'AssistantGrant';

    private _assistant!: AssistantClient;
    private _client!: Client;
    private _createdAt!: moment.Moment;
    private _lastUsedAt!: moment.Moment | null;
    private _revoked!: boolean;
    private _revokedAt!: moment.Moment | null;
    private _revokedBy!: User | null;
    private _user!: User;

    public get assistant(): AssistantClient {
        return this._assistant;
    }

    public set assistant(value: any) {
        this._setValue('_assistant', value, 'AssistantClient');
    }

    public get client(): Client {
        return this._client;
    }

    public set client(value: any) {
        this._setValue('_client', value, 'Client');
    }

    public get createdAt(): moment.Moment {
        return this._createdAt;
    }

    public set createdAt(value: any) {
        this._setValue('_createdAt', value, 'datetime');
    }

    public get lastUsedAt(): moment.Moment | null {
        return this._lastUsedAt;
    }

    public set lastUsedAt(value: any) {
        this._setValue('_lastUsedAt', value, 'datetime');
    }

    public get revoked(): boolean {
        return this._revoked;
    }

    public set revoked(value: any) {
        this._setValue('_revoked', value, 'boolean');
    }

    public get revokedAt(): moment.Moment | null {
        return this._revokedAt;
    }

    public set revokedAt(value: any) {
        this._setValue('_revokedAt', value, 'datetime');
    }

    /** Auteur de la révocation ; `null` pour une révocation au changement de mot de passe. */
    public get revokedBy(): User | null {
        return this._revokedBy;
    }

    public set revokedBy(value: any) {
        this._setValue('_revokedBy', value, 'User');
    }

    public get user(): User {
        return this._user;
    }

    public set user(value: any) {
        this._setValue('_user', value, 'User');
    }

}
